import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_tilefix-scheduler/artifacts/c05hbcds_IMG_1809.png";

const Hero = () => {
  const features = [
    'Free Estimates',
    '15+ Years Experience',
    'Licensed & Insured'
  ];

  return (
    <section className="hero-section">
      {/* Background Image */}
      <div className="hero-background">
        <img
          src="https://images.unsplash.com/photo-1558211583-ecfebb03748b?w=1920&q=80"
          alt="Beautiful bathroom tile work"
          className="hero-image"
        />
        <div className="hero-overlay" />
      </div>

      {/* Content */}
      <div className="container relative z-10">
        <div className="flex flex-col items-center text-center">
          {/* Centered Logo */}
          <div className="mb-8 animate-fade-in-up">
            <img 
              src={LOGO_URL} 
              alt="Top Notch Tile LLC" 
              className="h-40 md:h-56 w-auto mx-auto"
            />
          </div>

          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#1B3A5F]/80 px-4 py-2 rounded-full mb-6 animate-fade-in-up animate-delay-1">
            <span className="w-2 h-2 bg-[#F7931E] rounded-full" />
            <span className="text-[#F7931E] font-semibold text-sm uppercase tracking-wide">
              Cape Cod's Premier Tile Experts
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="brand-display mb-6 animate-fade-in-up animate-delay-2">
            Expert Interior<br />
            <span className="text-white">Tile Installation</span>
          </h1>

          {/* Subheading */}
          <p className="body-large text-[#c5d3e3] mb-8 max-w-2xl animate-fade-in-up animate-delay-3">
            Transform your home with stunning tile work. From bathrooms to kitchens, 
            backsplashes to floors — we bring precision craftsmanship to every project.
          </p>

          {/* Features */}
          <div className="flex flex-wrap justify-center gap-4 mb-10 animate-fade-in-up animate-delay-3">
            {features.map((feature) => (
              <div key={feature} className="flex items-center gap-2 text-white">
                <CheckCircle size={18} className="text-[#F7931E]" />
                <span className="font-medium">{feature}</span>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-wrap justify-center gap-4 animate-fade-in-up animate-delay-4">
            <Link to="/estimate" className="btn-primary">
              Get Free Estimate
              <ArrowRight size={18} />
            </Link>
            <a href="#services" onClick={(e) => {
              e.preventDefault();
              document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' });
            }} className="btn-secondary">
              View Our Work
            </a>
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0d1f33] to-transparent z-10" />
    </section>
  );
};

export default Hero;
